import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-key-financial',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './key-financial.component.html',
  styleUrl: './key-financial.component.css'
})
export class KeyFinancialComponent {

  baseApiUrl = environment.baseApiUrl;
  
}
